module.exports = __webpack_public_path__ + "static/media/alawasem.d4437e2f.webp";